import { render, staticRenderFns } from "./date-alert-banner.vue?vue&type=template&id=8a9d41c6&scoped=true&"
import script from "./date-alert-banner.vue?vue&type=script&lang=js&"
export * from "./date-alert-banner.vue?vue&type=script&lang=js&"
import style0 from "./date-alert-banner.vue?vue&type=style&index=0&id=8a9d41c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d41c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
